import React from 'react';

export const Heading: React.FC<{children: React.ReactNode, level?: 1 | 2 | 3, className?: string}> = ({children, level=2, className=''}) => {
    if(level === 1) return <h1 className={`text-4xl md:text-6xl font-bold tracking-tight text-white ${className}`}>{children}</h1>;
    if(level === 3) return <h3 className={`text-xl font-bold text-white mb-2 ${className}`}>{children}</h3>;
    return <h2 className={`text-3xl md:text-4xl font-bold text-white mb-6 tracking-tight ${className}`}>{children}</h2>;
}

